(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-watch-buy"] && !Shopify.designMode) return;
  try {
    
const wrapper = document.querySelector('.reels-wrapper');
const prevBtn = document.querySelector('.reels-btn.prev');
const nextBtn = document.querySelector('.reels-btn.next');

const cardWidth = 280; // reel width + gap

if (prevBtn && nextBtn && wrapper) {
  prevBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: -cardWidth, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: cardWidth, behavior: 'smooth' });
  });
}

/* DRAG SUPPORT */
let isDown = false;
let startX;
let scrollLeft;

wrapper.addEventListener('mousedown', e => {
  isDown = true;
  startX = e.pageX - wrapper.offsetLeft;
  scrollLeft = wrapper.scrollLeft;
});

wrapper.addEventListener('mouseleave', () => isDown = false);
wrapper.addEventListener('mouseup', () => isDown = false);

wrapper.addEventListener('mousemove', e => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - wrapper.offsetLeft;
  const walk = (x - startX) * 1.2;
  wrapper.scrollLeft = scrollLeft - walk;
});

/* MODAL LOGIC (unchanged) */
document.querySelectorAll('.reel-card').forEach(card => {
  card.addEventListener('click', () => {
    const modal = document.getElementById('reelModal');
    const video = document.getElementById('modalVideo');

    video.src = card.dataset.video;
    video.muted = true;
    video.play().then(() => video.muted = false);

    document.getElementById('modalProductTitle').innerText = card.dataset.productTitle;
    document.getElementById('modalProductPrice').innerText = card.dataset.productPrice;
    document.getElementById('modalProductImage').src = card.dataset.productImage;
    document.getElementById('modalProductBtn').href = card.dataset.productUrl;

    modal.classList.add('active');
  });
});

document.getElementById('reelClose').addEventListener('click', () => {
  const modal = document.getElementById('reelModal');
  const video = document.getElementById('modalVideo');
  video.pause();
  video.src = '';
  modal.classList.remove('active');
});

  } catch(e) { console.error(e); }
})();
})();
